import './ShellHeader.css';

export function ShellHeader() {
  return (
    <header className="shell-header">
      <div className="shell-header__inner">
        <span className="shell-header__brand" aria-label="It's My News">
          📰 It's My News
        </span>
      </div>
    </header>
  );
}
